import React from "react";
import PropTypes from "prop-types";

import SectionStreamWrapper from "stream/containers/SectionStreamWrapper";
import SmarterFasterHeader from "stream/components/SmarterFasterHeader";
import Stream from "stream/containers/Stream";
import FullStoryCard from "cards/containers/FullStoryCard";

import { DEFAULT_CARD_HEIGHT } from "config/constants";

export default function SmarterFaster(props) {
  return (
    <SectionStreamWrapper {...props}>
      {({ streamParams }) => {
        return (
          <React.Fragment>
            <SmarterFasterHeader />
            <Stream
              {...streamParams}
              defaultCardHeight={DEFAULT_CARD_HEIGHT.FULL_STORY_CARD}
              contentComponent={FullStoryCard}
              onlyShowTitleForA11y={true}
            />
          </React.Fragment>
        );
      }}
    </SectionStreamWrapper>
  );
}

SmarterFaster.propTypes = {
  slug: PropTypes.string.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }),
};
